<div class="glide" [class]="'glide-' + glideNumber" #glide>

    <div class="glide__track" data-glide-el="track">

            <ng-content></ng-content>

    </div>

</div>